webpackJsonp([218655834487403],{

/***/ 61:
/***/ (function(module, exports) {

	"use strict";
	
	function hash(str) {
	  var hash = 5381,
	      i    = str.length;
	
	  while(i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	   * integers. Since we want the results to be always positive, convert the
	   * signed int to an unsigned by doing an unsigned bitshift. */
	  return hash >>> 0;
	}
	
	module.exports = hash;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Based on Glamor's sheet
	https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
	*/
	
	var isProd = ({"NODE_ENV":"production","PUBLIC_DIR":"C:\\Users\\baris_000\\WebProjects\\barisozcetin-blog/public"}) && ("production") === 'production';
	var isString = function isString(o) {
	  return Object.prototype.toString.call(o) === '[object String]';
	};
	
	var StyleSheet = function () {
	  function StyleSheet() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$name = _ref.name,
	        name = _ref$name === undefined ? 'stylesheet' : _ref$name,
	        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
	        optimizeForSpeed = _ref$optimizeForSpeed === undefined ? isProd : _ref$optimizeForSpeed,
	        _ref$isBrowser = _ref.isBrowser,
	        isBrowser = _ref$isBrowser === undefined ? typeof window !== 'undefined' : _ref$isBrowser;
	
	    (0, _classCallCheck3.default)(this, StyleSheet);
	
	    invariant(isString(name), '`name` must be a string');
	    this._name = name;
	    this._deletedRulePlaceholder = '#' + name + '-deleted-rule____{}';
	
	    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
	    this._optimizeForSpeed = optimizeForSpeed;
	    this._isBrowser = isBrowser;
	
	    this._serverSheet = undefined;
	    this._tags = [];
	    this._injected = false;
	    this._rulesCount = 0;
	  }
	
	  (0, _createClass3.default)(StyleSheet, [{
	    key: 'setOptimizeForSpeed',
	    value: function setOptimizeForSpeed(bool) {
	      invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
	
	      invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
	      this.flush();
	      this._optimizeForSpeed = bool;
	      this.inject();
	    }
	  }, {
	    key: 'isOptimizeForSpeed',
	    value: function isOptimizeForSpeed() {
	      return this._optimizeForSpeed;
	    }
	  }, {
	    key: 'inject',
	    value: function inject() {
	      var _this = this;
	
	      invariant(!this._injected, 'sheet already injected');
	      this._injected = true;
	      if (this._isBrowser && this._optimizeForSpeed) {
	        this._tags[0] = this.makeStyleTag(this._name);
	        this._optimizeForSpeed = 'insertRule' in this.getSheet();
	        if (!this._optimizeForSpeed) {
	          if (!isProd) {
	            console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.'); // eslint-disable-line no-console
	          }
	          this.flush();
	          this._injected = true;
	        }
	        return;
	      }
	
	      this._serverSheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule, index) {
	          if (typeof index === 'number') {
	            _this._serverSheet.cssRules[index] = { cssText: rule };
	          } else {
	            _this._serverSheet.cssRules.push({ cssText: rule });
	          }
	          return index;
	        },
	        deleteRule: function deleteRule(index) {
	          _this._serverSheet.cssRules[index] = null;
	        }
	      };
	    }
	  }, {
	    key: 'getSheetForTag',
	    value: function getSheetForTag(tag) {
	      if (tag.sheet) {
	        return tag.sheet;
	      }
	
	      // this weirdness brought to you by firefox
	      for (var i = 0; i < document.styleSheets.length; i++) {
	        if (document.styleSheets[i].ownerNode === tag) {
	          return document.styleSheets[i];
	        }
	      }
	    }
	  }, {
	    key: 'getSheet',
	    value: function getSheet() {
	      return this.getSheetForTag(this._tags[this._tags.length - 1]);
	    }
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule, index) {
	      invariant(isString(rule), '`insertRule` accepts only strings');
	
	      if (!this._isBrowser) {
	        if (typeof index !== 'number') {
	          index = this._serverSheet.cssRules.length;
	        }
	        this._serverSheet.insertRule(rule, index);
	        return this._rulesCount++;
	      }
	
	      if (this._optimizeForSpeed) {
	        var sheet = this.getSheet();
	        if (typeof index !== 'number') {
	          index = sheet.cssRules.length;
	        }
	        // this weirdness for perf, and chrome's weird bug
	        // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	        try {
	          sheet.insertRule(rule, index);
	        } catch (err) {
	          if (!isProd) {
	            console.warn('StyleSheet: illegal rule: \n\n' + rule + '\n\nSee https://stackoverflow.com/q/20007992 for more info'); // eslint-disable-line no-console
	          }
	          return -1;
	        }
	      } else {
	        var insertionPoint = this._tags[index];
	        this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
	      }
	
	      return this._rulesCount++;
	    }
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule(index, rule) {
	      if (this._optimizeForSpeed || !this._isBrowser) {
	        var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;
	        if (!rule.trim()) {
	          rule = this._deletedRulePlaceholder;
	        }
	
	        if (!sheet.cssRules[index]) {
	          // @TBD Should we throw an error?
	          return index;
	        }
	
	        sheet.deleteRule(index);
	
	        try {
	          sheet.insertRule(rule, index);
	        } catch (err) {
	          if (!isProd) {
	            console.warn('StyleSheet: illegal rule: \n\n' + rule + '\n\nSee https://stackoverflow.com/q/20007992 for more info'); // eslint-disable-line no-console
	          }
	          // In order to preserve the indices we insert a deleteRulePlaceholder
	          sheet.insertRule(this._deletedRulePlaceholder, index);
	        }
	      } else {
	        var tag = this._tags[index];
	        invariant(tag, 'old rule at index `' + index + '` not found');
	        tag.textContent = rule;
	      }
	      return index;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(index) {
	      if (!this._isBrowser) {
	        this._serverSheet.deleteRule(index);
	        return;
	      }
	
	      if (this._optimizeForSpeed) {
	        this.replaceRule(index, '');
	      } else {
	        var tag = this._tags[index];
	        invariant(tag, 'rule at index `' + index + '` not found');
	        tag.parentNode.removeChild(tag);
	        this._tags[index] = null;
	      }
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      this._injected = false;
	      this._rulesCount = 0;
	      if (this._isBrowser) {
	        this._tags.forEach(function (tag) {
	          return tag && tag.parentNode.removeChild(tag);
	        });
	        this._tags = [];
	      } else {
	        // simpler on server
	        this._serverSheet.cssRules = [];
	      }
	    }
	  }, {
	    key: 'cssRules',
	    value: function cssRules() {
	      var _this2 = this;
	
	      if (!this._isBrowser) {
	        return this._serverSheet.cssRules;
	      }
	      return this._tags.reduce(function (rules, tag) {
	        if (tag) {
	          rules = rules.concat(_this2.getSheetForTag(tag).cssRules.map(function (rule) {
	            return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
	          }));
	        } else {
	          rules.push(null);
	        }
	        return rules;
	      }, []);
	    }
	  }, {
	    key: 'makeStyleTag',
	    value: function makeStyleTag(name, cssString, relativeToTag) {
	      if (cssString) {
	        invariant(isString(cssString), 'makeStyleTag acceps only strings as second parameter');
	      }
	      var tag = document.createElement('style');
	      tag.type = 'text/css';
	      tag.setAttribute('data-' + name, '');
	      if (cssString) {
	        tag.appendChild(document.createTextNode(cssString));
	      }
	      var head = document.head || document.getElementsByTagName('head')[0];
	      if (relativeToTag) {
	        head.insertBefore(tag, relativeToTag);
	      } else {
	        head.appendChild(tag);
	      }
	      return tag;
	    }
	  }, {
	    key: 'length',
	    get: function get() {
	      return this._rulesCount;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	exports.default = StyleSheet;
	
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error('StyleSheet: ' + message + '.');
	  }
	}

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(95);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _slicedToArray2 = __webpack_require__(97);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(96);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(36);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(35);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.flush = flush;
	
	var _react = __webpack_require__(2);
	
	var _stylesheetRegistry = __webpack_require__(64);
	
	var _stylesheetRegistry2 = _interopRequireDefault(_stylesheetRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleSheetRegistry = new _stylesheetRegistry2.default();
	
	var JSXStyle = function (_Component) {
	  (0, _inherits3.default)(JSXStyle, _Component);
	
	  function JSXStyle() {
	    (0, _classCallCheck3.default)(this, JSXStyle);
	    return (0, _possibleConstructorReturn3.default)(this, (JSXStyle.__proto__ || (0, _getPrototypeOf2.default)(JSXStyle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JSXStyle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      styleSheetRegistry.add(this.props);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.css !== nextProps.css;
	    }
	
	    // To avoid FOUC, we process new changes
	    // on `componentWillUpdate` rather than `componentDidUpdate`.
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      styleSheetRegistry.update(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      styleSheetRegistry.remove(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'dynamic',
	    value: function dynamic(info) {
	      return info.map(function (tagInfo) {
	        var _tagInfo = (0, _slicedToArray3.default)(tagInfo, 2),
	            baseId = _tagInfo[0],
	            props = _tagInfo[1];
	
	        return styleSheetRegistry.computeId(baseId, props);
	      }).join(' ');
	    }
	  }]);
	  return JSXStyle;
	}(_react.Component);
	
	exports.default = JSXStyle;
	function flush() {
	  var cssRules = styleSheetRegistry.cssRules();
	  styleSheetRegistry.flush();
	  return new _map2.default(cssRules);
	}

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(67);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _stringHash = __webpack_require__(61);
	
	var _stringHash2 = _interopRequireDefault(_stringHash);
	
	var _stylesheet = __webpack_require__(62);
	
	var _stylesheet2 = _interopRequireDefault(_stylesheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sanitize = function sanitize(rule) {
	  return rule.replace(/\/style/ig, '\\/style');
	};
	
	var StyleSheetRegistry = function () {
	  function StyleSheetRegistry() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$styleSheet = _ref.styleSheet,
	        styleSheet = _ref$styleSheet === undefined ? null : _ref$styleSheet,
	        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
	        optimizeForSpeed = _ref$optimizeForSpeed === undefined ? false : _ref$optimizeForSpeed,
	        _ref$isBrowser = _ref.isBrowser,
	        isBrowser = _ref$isBrowser === undefined ? typeof window !== 'undefined' : _ref$isBrowser;
	
	    (0, _classCallCheck3.default)(this, StyleSheetRegistry);
	
	    this._sheet = styleSheet || new _stylesheet2.default({
	      name: 'styled-jsx',
	      optimizeForSpeed: optimizeForSpeed
	    });
	
	    this._sheet.inject();
	    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
	      this._sheet.setOptimizeForSpeed(optimizeForSpeed);
	      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	    }
	
	    this._isBrowser = isBrowser;
	
	    this._fromServer = undefined;
	    this._indices = {};
	    this._instancesCounts = {};
	
	    this.computeId = this.createComputeId();
	    this.computeSelector = this.createComputeSelector();
	  }
	
	  (0, _createClass3.default)(StyleSheetRegistry, [{
	    key: 'add',
	    value: function add(props) {
	      var _this = this;
	
	      if (undefined === this._optimizeForSpeed) {
	        this._optimizeForSpeed = Array.isArray(props.css);
	        this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
	        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	      }
	
	      if (this._isBrowser && !this._fromServer) {
	        this._fromServer = this.selectFromServer();
	        this._instancesCounts = (0, _keys2.default)(this._fromServer).reduce(function (acc, tagName) {
	          acc[tagName] = 0;
	          return acc;
	        }, {});
	      }
	
	      var _getIdAndRules = this.getIdAndRules(props),
	          styleId = _getIdAndRules.styleId,
	          rules = _getIdAndRules.rules;
	
	      // Deduping: just increase the instances count.
	
	
	      if (styleId in this._instancesCounts) {
	        this._instancesCounts[styleId] += 1;
	        return;
	      }
	
	      var indices = rules.map(function (rule) {
	        return _this._sheet.insertRule(rule);
	      })
	      // Filter out invalid rules
	      .filter(function (index) {
	        return index !== -1;
	      });
	
	      if (indices.length > 0) {
	        this._indices[styleId] = indices;
	        this._instancesCounts[styleId] = 1;
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(props) {
	      var _this2 = this;
	
	      var _getIdAndRules2 = this.getIdAndRules(props),
	          styleId = _getIdAndRules2.styleId;
	
	      invariant(styleId in this._instancesCounts, 'styleId: `' + styleId + '` not found');
	      this._instancesCounts[styleId] -= 1;
	
	      if (this._instancesCounts[styleId] < 1) {
	        var tagFromServer = this._fromServer && this._fromServer[styleId];
	        if (tagFromServer) {
	          tagFromServer.parentNode.removeChild(tagFromServer);
	          delete this._fromServer[styleId];
	        } else {
	          this._indices[styleId].forEach(function (index) {
	            return _this2._sheet.deleteRule(index);
	          });
	          delete this._indices[styleId];
	        }
	        delete this._instancesCounts[styleId];
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(props, nextProps) {
	      this.add(nextProps);
	      this.remove(props);
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      this._sheet.flush();
	      this._sheet.inject();
	      this._fromServer = undefined;
	      this._indices = {};
	      this._instancesCounts = {};
	
	      this.computeId = this.createComputeId();
	      this.computeSelector = this.createComputeSelector();
	    }
	  }, {
	    key: 'cssRules',
	    value: function cssRules() {
	      var _this3 = this;
	
	      var fromServer = this._fromServer ? (0, _keys2.default)(this._fromServer).map(function (styleId) {
	        return [styleId, _this3._fromServer[styleId]];
	      }) : [];
	      var cssRules = this._sheet.cssRules();
	
	      return fromServer.concat((0, _keys2.default)(this._indices).map(function (styleId) {
	        return [styleId, _this3._indices[styleId].map(function (index) {
	          return cssRules[index].cssText;
	        }).join('\n')];
	      }));
	    }
	
	    /**
	     * createComputeId
	     *
	     * Creates a function to compute and memoize a jsx id from a basedId and optionally props.
	     */
	
	  }, {
	    key: 'createComputeId',
	    value: function createComputeId() {
	      var cache = {};
	      return function (baseId, props) {
	        if (!props) {
	          return 'jsx-' + baseId;
	        }
	        var propsToString = String(props);
	        var key = baseId + propsToString;
	        // return `jsx-${hashString(`${baseId}-${propsToString}`)}`
	        if (!cache[key]) {
	          cache[key] = 'jsx-' + (0, _stringHash2.default)(baseId + '-' + propsToString);
	        }
	        return cache[key];
	      };
	    }
	
	    /**
	     * createComputeSelector
	     *
	     * Creates a function to compute and memoize dynamic selectors.
	     */
	
	  }, {
	    key: 'createComputeSelector',
	    value: function createComputeSelector() {
	      var selectoPlaceholderRegexp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : /__jsx-style-dynamic-selector/g;
	
	      var cache = {};
	      return function (id, css) {
	        // Sanitize SSR-ed CSS.
	        // Client side code doesn't need to be sanitized since we use
	        // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
	        if (!this._isBrowser) {
	          css = sanitize(css);
	        }
	        var idcss = id + css;
	        if (!cache[idcss]) {
	          cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
	        }
	        return cache[idcss];
	      };
	    }
	  }, {
	    key: 'getIdAndRules',
	    value: function getIdAndRules(props) {
	      var _this4 = this;
	
	      if (props.dynamic) {
	        var styleId = this.computeId(props.styleId, props.dynamic);
	        return {
	          styleId: styleId,
	          rules: Array.isArray(props.css) ? props.css.map(function (rule) {
	            return _this4.computeSelector(styleId, rule);
	          }) : [this.computeSelector(styleId, props.css)]
	        };
	      }
	
	      return {
	        styleId: this.computeId(props.styleId),
	        rules: Array.isArray(props.css) ? props.css : [props.css]
	      };
	    }
	
	    /**
	     * selectFromServer
	     *
	     * Collects style tags from the document with id __jsx-XXX
	     */
	
	  }, {
	    key: 'selectFromServer',
	    value: function selectFromServer() {
	      var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
	
	      return elements.reduce(function (acc, element) {
	        var id = element.id.slice(2);
	        acc[id] = element;
	        return acc;
	      }, {});
	    }
	  }]);
	  return StyleSheetRegistry;
	}();
	
	exports.default = StyleSheetRegistry;
	
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error('StyleSheetRegistry: ' + message + '.');
	  }
	}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63)


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _page = __webpack_require__(232);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _post = __webpack_require__(233);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		page: _page2.default,
		post: _post2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(93);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page(props) {
		return _react2.default.createElement(
			'div',
			null,
			props
		);
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Post = undefined;
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(93);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import React from 'react';
	// import Components from './components.js';
	
	// const Page = (props) => (
	// 	<div>
	// 		{props.blok.body &&
	// 			props.blok.body.map((blok) => React.createElement(Components[blok.component], { key: blok._uid, blok: blok }))}
	// 	</div>
	// );
	
	// export default Page;
	
	var Post = exports.Post = function (_Component) {
		_inherits(Post, _Component);
	
		function Post() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Post);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				content: ''
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Post.prototype.componentDidMount = function componentDidMount() {
			//console.log(this.props);
			// this.setState({ content: this.props.blok.content });
			// this.setState(
			// 	(prev) => ({ content: this.props.blok.content }),
			// 	() => {
			// 		this.refs.test.innerHTML = this.state.content;
			// 	}
			// );
			// this.refs.test.innerHTML = 'Hello';
		};
	
		Post.prototype.render = function render() {
			// console.log(this.props);
			var postDate = new Date(this.props.dateTime);
			// console.log()
			return _react2.default.createElement(
				'div',
				{
					className: 'jsx-3757608587' + ' ' + 'post-grid'
				},
				_react2.default.createElement(
					'div',
					{
						className: 'jsx-3757608587' + ' ' + 'post-header'
					},
					_react2.default.createElement(
						'h1',
						{
							className: 'jsx-3757608587'
						},
						this.props.blok.title
					),
					_react2.default.createElement(
						'time',
						{ dateTime: postDate, className: 'jsx-3757608587'
						},
						postDate.toDateString()
					),
					_react2.default.createElement(
						'div',
						{
							className: 'jsx-3757608587' + ' ' + 'social-buttons'
						},
						_react2.default.createElement(
							'button',
							{
								className: 'jsx-3757608587' + ' ' + 'social-button btn btn-lg btn-facebook text-light'
							},
							_react2.default.createElement('i', {
								className: 'jsx-3757608587' + ' ' + 'fab fa-facebook-f'
							})
						),
						_react2.default.createElement(
							'button',
							{
								className: 'jsx-3757608587' + ' ' + 'social-button btn btn-lg btn-twitter text-light'
							},
							_react2.default.createElement('i', {
								className: 'jsx-3757608587' + ' ' + 'fab fa-twitter'
							})
						),
						_react2.default.createElement(
							'button',
							{
								className: 'jsx-3757608587' + ' ' + 'social-button btn btn-lg btn-linkedin text-light'
							},
							_react2.default.createElement('i', {
								className: 'jsx-3757608587' + ' ' + 'fab fa-linkedin-in'
							})
						)
					)
				),
				_react2.default.createElement(
					'div',
					{
						className: 'jsx-3757608587' + ' ' + 'post-image'
					},
					_react2.default.createElement('img', {
						src: this.props.blok.image ? this.props.blok.image.url : '/error.jpg',
						alt: this.props.blok.title,
						className: 'jsx-3757608587' + ' ' + 'img-responsive'
					})
				),
				_react2.default.createElement(
					'div',
					{
						className: 'jsx-3757608587' + ' ' + 'post-body'
					},
					_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.blok.content }, className: 'jsx-3757608587' + ' ' + 'content'
					})
				),
				_react2.default.createElement(_style2.default, {
					styleId: '3757608587',
					css: ['.post-body.jsx-3757608587{font-size:0.9rem;line-height:27px;}', '.social-buttons.jsx-3757608587{display:grid;grid-template-columns:repeat(auto-fill,minmax(50px,90px));grid-gap:5px;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;margin-top:2rem;margin-bottom:2rem;}', '.btn-facebook.jsx-3757608587{background-color:#3b5a99;}', '.btn-twitter.jsx-3757608587{background-color:rgb(37,168,224);}', '.btn-linkedin.jsx-3757608587{background-color:#0d7bb7;}', '.text-blue.jsx-3757608587{color:#209cee;}', 'img.jsx-3757608587{max-height:480px;width:100%;object-fit:cover;}', '.content.jsx-3757608587{word-wrap:break-word;padding:5px;line-height:2;}', '@media screen and (min-width:768px){.content.jsx-3757608587{padding:20px;}}', '@media screen and (max-width:767px){h1.jsx-3757608587{font-size:1.8rem;text-align:center;}}', '.content.jsx-3757608587{white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;}', '.image-container.jsx-3757608587{border:1px solid red;}', 'img.jsx-3757608587{margin:auto;}', 'button.btn.jsx-3757608587{border:none;}']
				})
			);
		};
	
		return Post;
	}(_react.Component);
	
	exports.default = Post;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sideBar = function sideBar() {
		return _react2.default.createElement(
			"div",
			{
				className: "jsx-3107825142" + " " + "sidebar--container"
			},
			_react2.default.createElement("hr", {
				className: "jsx-3107825142"
			}),
			_react2.default.createElement(
				"div",
				{
					className: "jsx-3107825142" + " " + "form-group text-center subscribe-container"
				},
				_react2.default.createElement(
					"p",
					{
						className: "jsx-3107825142"
					},
					"You can subscribe to my mail list and stay up to date with my posts."
				),
				_react2.default.createElement("input", { type: "text", name: "email", id: "", placeholder: "Email Address", disabled: true, className: "jsx-3107825142" + " " + "form-input mb-2"
				}),
				_react2.default.createElement(
					"button",
					{ type: "submit", disabled: true, className: "jsx-3107825142" + " " + "btn btn-dark btn-block"
					},
					"SUBSCRIBE"
				),
				_react2.default.createElement(
					"span",
					{
						className: "jsx-3107825142" + " " + "coming"
					},
					"COMING SOON"
				)
			),
			_react2.default.createElement(
				"div",
				{
					className: "jsx-3107825142" + " " + "btn-group btn-group-block"
				},
				_react2.default.createElement(
					"a",
					{ href: "https://www.facebook.com", className: "jsx-3107825142" + " " + "s-circle btn-lg btn-social"
					},
					_react2.default.createElement("i", {
						className: "jsx-3107825142" + " " + "fab fa-facebook-f"
					})
				),
				_react2.default.createElement(
					"a",
					{ href: "https://www.twitter.com/baris_ozcetin", className: "jsx-3107825142" + " " + "s-circle btn-lg btn-social"
					},
					_react2.default.createElement("i", {
						className: "jsx-3107825142" + " " + "fab fa-twitter"
					})
				),
				_react2.default.createElement(
					"a",
					{ href: "https://www.linkedin.com/in/baris-ozcetin/", className: "jsx-3107825142" + " " + "s-circle btn-lg btn-social"
					},
					_react2.default.createElement("i", {
						className: "jsx-3107825142" + " " + "fab fa-linkedin-in"
					})
				),
				_react2.default.createElement(
					"a",
					{ href: "https://github.com/barisozcetin/", className: "jsx-3107825142" + " " + "s-circle btn-lg btn-social"
					},
					_react2.default.createElement("i", {
						className: "jsx-3107825142" + " " + "fab fa-github"
					})
				)
			),
			_react2.default.createElement(_style2.default, {
				styleId: "3107825142",
				css: [".s-circle.jsx-3107825142{border:1px black solid;color:white;width:50px;height:50px;background-color:black;}", ".btn-social.jsx-3107825142{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".btn-group.jsx-3107825142{-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;}", ".subscribe-container.jsx-3107825142{position:relative;}", ".coming.jsx-3107825142{position:absolute;top:40px;border:red 8px solid;color:red;-webkit-transform:rotate(345deg);-ms-transform:rotate(345deg);transform:rotate(345deg);font-size:1.5rem;font-weight:bold;width:90%;height:40%;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;justify-self:center;display:grid;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;}", "@media only screen and (min-width:1024px){.sidebar--container.jsx-3107825142{padding-top:150px;}hr.jsx-3107825142{display:none;}}"]
			})
		);
	};
	
	exports.default = sideBar;
	module.exports = exports["default"];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(93);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _sideBar = __webpack_require__(94);
	
	var _sideBar2 = _interopRequireDefault(_sideBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoryblokEntry = function (_React$Component) {
		_inherits(StoryblokEntry, _React$Component);
	
		function StoryblokEntry(props) {
			_classCallCheck(this, StoryblokEntry);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			var story = _extends({}, props.pathContext.story);
			story.content = JSON.parse(story.content);
			_this.state = { story: story };
			return _this;
		}
	
		StoryblokEntry.prototype.render = function render() {
			var content = this.state.story.content;
			// console.log(content);
			var dateTime = this.state.story.published_at;
			return _react2.default.createElement(
				'div',
				{
					className: 'jsx-2135702881' + ' ' + 'main-grid pt-2 mt-2'
				},
				_react2.default.createElement(_components2.default[content.component], {
					key: content._uid,
					blok: content,
					dateTime: dateTime
				}),
				' ',
				_react2.default.createElement(_sideBar2.default, null),
				' ',
				_react2.default.createElement(_style2.default, {
					styleId: '2135702881',
					css: ['.main-grid.jsx-2135702881{display:grid;}', '@media only screen and (min-width:480px){.main-grid.jsx-2135702881{grid-template-columns:3fr 1fr;grid-gap:40px;}}']
				})
			);
		};
	
		return StoryblokEntry;
	}(_react2.default.Component);
	
	exports.default = StoryblokEntry;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-storyblok-entry-js-b37a756922e195bd1ac6.js